import { UnexpectedError } from '@economic/react-app';
import useQuery from '~/app/shared/hooks/useQuery';
import useCachedQuery from '~/app/shared/hooks/useCachedQuery';
import { ChangeSubscriptionDetails } from '~/app/pages/settings/company/subscription/types';
import { LoadingBox } from '~/shared-ui';
import ChoosePlanPage from './ChoosePlanPage';
import { UpgradePlanInfo } from './shared';
import './style.css';

interface Props {
    onHide: () => void;
}

export function PlanUpgradeDialog({ onHide }: Props) {
    const upgradeQuery = useCachedQuery<UpgradePlanInfo>('home/upgrade');
    const changeSubscriptionDetailsQuery = useQuery<ChangeSubscriptionDetails>(`company/change-subscription-details`);

    if (upgradeQuery.loading || changeSubscriptionDetailsQuery.loading) {
        return <LoadingBox />;
    }

    if (upgradeQuery.error || changeSubscriptionDetailsQuery.error) {
        return <UnexpectedError />;
    }

    return <ChoosePlanPage data={upgradeQuery.data} subscriptionDetails={changeSubscriptionDetailsQuery.data} hide={onHide} />;
}
